/**
 * External Imports
 */
import { Dispatch, FC, SetStateAction } from 'react';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

/**
 * Internal Imports
 */
import { Dropdown, IDropdownProps } from '../../shared/dropdowns';

interface IDeptMultiSelectDropdownProps extends IDropdownProps {
  options: any[];
  searchResults?: string[];
  selectedDepts: string[];
  setActiveSearch: Dispatch<SetStateAction<string>>;
  setQuery: Dispatch<SetStateAction<string>>;
  setSelectedDepts: Dispatch<SetStateAction<string[]>>;
}

const DeptMultiSelectDropdown: FC<IDeptMultiSelectDropdownProps> = ({
  focused,
  options = [],
  query,
  searchResults,
  selectedDepts,
  setActiveSearch,
  setQuery,
  setSelectedDepts,
  ...rest
}) => {
  return (
    <Dropdown focused={focused} query={query} {...rest}>
      {!query && (
        // TODO: Add space around checkmark thru option padding-right: calc(1.6rem + 20px);
        <div
          aria-selected={
            options.length > 0 && selectedDepts.length === options.length
          }
          className={`dropdown-hover-item checkable ${
            options.length > 0 && selectedDepts.length === options.length
              ? 'selected'
              : ''
          }`}
          key="All-Departments"
          role="option"
          tabIndex={0}
          onClick={() =>
            setSelectedDepts(
              selectedDepts.length === options.length ? [] : [...options]
            )
          }
          onKeyDown={() =>
            setSelectedDepts(
              selectedDepts.length === options.length ? [] : [...options]
            )
          }
        >
          <div>
            All
            {options.length > 0 && selectedDepts.length === options.length && (
              <NeuIcon className="custom-checkmark" color="blue">
                check
              </NeuIcon>
            )}
          </div>
        </div>
      )}
      {focused && searchResults && searchResults.length > 0 ? (
        [...searchResults].sort().map((dept: string) => {
          const selected = options.length > 0 && selectedDepts.includes(dept);
          return (
            <div
              aria-selected={selected}
              className={`dropdown-hover-item checkable ${
                selected ? 'selected' : ''
              }`}
              key={dept}
              role="option"
              tabIndex={0}
              onClick={() => {
                setSelectedDepts(
                  selectedDepts.findIndex((d: string) => dept === d) === -1
                    ? [...selectedDepts, dept]
                    : selectedDepts.filter((d: string) => dept !== d)
                );
                setActiveSearch('');
                setQuery('');
              }}
              onKeyDown={() => {
                setSelectedDepts(
                  selectedDepts.findIndex((d: string) => dept === d) === -1
                    ? [...selectedDepts, dept]
                    : selectedDepts.filter((d: string) => dept !== d)
                );
                setActiveSearch('');
                setQuery('');
              }}
            >
              <div>
                {dept}
                {selected && (
                  <NeuIcon className="custom-checkmark" color="blue">
                    check
                  </NeuIcon>
                )}
              </div>
            </div>
          );
        })
      ) : searchResults && searchResults.length === 0 ? (
        <div className="dropdown-search-no-result">No results found!</div>
      ) : (
        [...options].sort().map((dept: string) => {
          const selected = options.length > 0 && selectedDepts.includes(dept);
          return (
            <div
              aria-selected={selected}
              className={`dropdown-hover-item checkable ${
                selected ? 'selected' : ''
              }`}
              key={dept}
              role="option"
              tabIndex={0}
              onClick={() =>
                setSelectedDepts(
                  selectedDepts.findIndex((d: string) => dept === d) === -1
                    ? [...selectedDepts, dept]
                    : selectedDepts.filter((d: string) => dept !== d)
                )
              }
              onKeyDown={() =>
                setSelectedDepts(
                  selectedDepts.findIndex((d: string) => dept === d) === -1
                    ? [...selectedDepts, dept]
                    : selectedDepts.filter((d: string) => dept !== d)
                )
              }
            >
              <div>
                {dept}
                {selected && (
                  <NeuIcon className="custom-checkmark" color="blue">
                    check
                  </NeuIcon>
                )}
              </div>
            </div>
          );
        })
      )}
    </Dropdown>
  );
};

export default DeptMultiSelectDropdown;
